import { render, staticRenderFns } from "./ShowItemDetailsDialog.vue?vue&type=template&id=19bfc3fa"
import script from "./ShowItemDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ShowItemDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports